module.exports = __webpack_public_path__ + "img/P4-2-2.d1eb8d8b.png";